import Vue from 'vue'
import './utils/environment.js'
import './permission'
import '@babel/polyfill'
import App from './App.vue'
import router from "./router"
import 'amfe-flexible'
import axios from './utils/axios'
import './assets/iconfont/iconfont.css' //iconfont图标
import Vant from 'vant'
import "vant/lib/index.css"
import { Toast } from 'vant'
import playVideos from "@/components/playVideos/playVideos"
// import noGoods from "@/components/goods/noGoods"
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import store from "./store"
import './utils/touch.js'
import VueTouch from 'vue-touch'
import { Lazyload } from 'vant'
import BaiduMap from 'vue-baidu-map'
import VueClipboard from 'vue-clipboard2';
import md5 from 'js-md5';
import Vconsole from 'vconsole'

Vue.use(VueClipboard);
Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(Toast, { duration: 1000 });
Vue.prototype.$axios = axios;


// Vue.component('no-goods', noGoods);
Vue.component('play-videos', playVideos);
Vue.config.productionTip = false
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'XBhQ8xfErr3pmn1vIzX1ntI6b4Sv2LYH'
})

Vue.prototype.$md5 = md5;
Vue.prototype.GetQueryString = function (name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.href.split('?')[1] ? window.location.href.split('?')[1].match(reg) : null;
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}
store.commit("user/SET_communityShopId", Vue.prototype.GetQueryString('communityShopId'));
store.commit("user/SET_memberId", Vue.prototype.GetQueryString('memberId'));
store.commit("user/SET_nickname", Vue.prototype.GetQueryString('nickname'));
store.commit("user/SET_phone", Vue.prototype.GetQueryString('phone'));
store.commit("user/SET_longitude", Vue.prototype.GetQueryString('lng'));
store.commit("user/SET_latitude", Vue.prototype.GetQueryString('lat'));
store.commit("user/SET_areaId", Vue.prototype.GetQueryString('areaId'));
store.commit("user/SET_cityId", Vue.prototype.GetQueryString('cityId'));
store.commit("user/SET_token", Vue.prototype.GetQueryString('token'));

let ua = window.navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == "micromessenger") {
  //微信环境
  wx.miniProgram.getEnv(function (res) {
    if (res.miniprogram) {
      //小程序环境下逻辑
      store.commit("user/SET_ambientType", 0);
    }
  });
} else {
  
  //非微信环境逻辑
  let u = navigator.userAgent;
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
  let isOS = isAndroid ? true : false;
  // let vConsole = new Vconsole()
  // Vue.use(vConsole)
  if (isOS) {
    
    // 安卓环境
    store.commit("user/SET_ambientType", 1);
  } else {
    // IOS环境
    store.commit("user/SET_ambientType", 2);
  }
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
